<template>
  <AceEditor v-model="val" v-bind="$props" @init="init" :options="options" />
</template>

<script>
import AceEditor from 'vuejs-ace-editor';

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    lang: String,
    height: [String, Number]
  },
  components: {
    AceEditor
  },
  data() {
    return {
      options: {
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        highlightActiveLine: true,
        enableSnippets: true,
        showLineNumbers: true,
        tabSize: 2,
        showPrintMargin: false,
        showGutter: true,
      }
    }
  },
  methods: {
    init() {
      require('brace/ext/language_tools')
      require('brace/theme/chrome')
      if(this.lang == "xml") {
        require('brace/mode/xml')
        require('brace/snippets/xml')
      } else if(this.lang == "json") {
        require('brace/mode/json')
        require('brace/snippets/json')
      }
    }
  },
  mounted() {
    if(this.value) this.$emit("input", this.value);
  },
  computed: {
    val: {
      get() {
        return this.value || "";
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>
